import {
  convertPhysicalAlignmentToLogical,
  type Direction,
  type WithInherit,
  type LogicalAlignment,
} from '@wix/editor-elements-common-utils';
import type { DropDownMenuPlatformProps } from '../DropDownMenu.types';

export const getDirectionFallbackValue = (
  isRtl: DropDownMenuPlatformProps['rtl'],
): WithInherit<Direction> => (isRtl ? 'rtl' : 'inherit');

export const getAlignFallbackValue = (
  align: DropDownMenuPlatformProps['alignText'],
  isRtl: DropDownMenuPlatformProps['rtl'],
): LogicalAlignment => {
  const legacyDirection = isRtl ? 'rtl' : 'ltr';

  return convertPhysicalAlignmentToLogical(align, legacyDirection);
};
